import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { DescriptorDataService } from "../service/descriptor-data.service";

@Component({
  selector: "app-descriptor-data-item",
  templateUrl: "./descriptor-data-item.component.html",
  styleUrls: ["./descriptor-data-item.component.css"],
})
export class DescriptorDataItemComponent implements OnInit {
  @Input() id: any;
  constructor(private descriptorDataService: DescriptorDataService) {}

  descriptorDataObs$!: Observable<any>;

  ngOnInit(): void {
    this.fnObservable(this.id);
  }

  fnObservable(id: string) {
    this.descriptorDataObs$ = this.descriptorDataService.get(id);
  }
}
